import api from "../../Hooks/axiosApi";

export const clientLoginService = (loginData: any) => {
    const response = api.post(`/api/Login/CleintLogin`, loginData, {
        headers: {
            "Api_Key": "apikey",
        },
    });
    return response;
};

export const clientSignupService = (signupData: any) => {
    const response = api.post(`/api/Login/MppClientSignup`, signupData, {
        headers: {
            "Api_Key": "apikey",
        },
    });
    return response;
};

export const getMMPClientDetails = async (clientId: any) => {
    try {
        const response = await api.get(`/api/MppClient/GetMMPClientdetails/${clientId}`);
        if (!response.data || Object.keys(response.data).length === 0) {
            window.location.href = '/mmplogin';
            return null;
        }
        return response;
    } catch (error) {
        window.location.href = '/mmplogin';
        return null;
    }
};

export const updateMMPClientDetails = (updatedData: any) => {
    const response = api.post(`/api/MppClient/UpdateMMPClientdetails`, updatedData);
    return response;
};

export const changeClientPassword = (passwordData: any) => {
    const response = api.post(`/api/Login/Clientchangepassword`, passwordData);
    return response;
};

export const clientForgotpassword = (passwordData: any) => {
    const response = api.post(`/api/Login/ClientForgotpassword`, passwordData);
    return response;
};


// CRMADMIN SERVICES
export const crmLoginService = (loginData: any) => {
    const response = api.post(`/api/Login/CrmLogin`, loginData, {
        headers: {
            "Api_Key": "apikey",
        },
    });
    return response;
};